<template>
  <div class="Timer">
    <div style="display: flex; justify-content: space-between;">
      <div class="day">
          <span class="number" v-if="starttime !== 0 && endtime !== 0">{{ days }}</span>
          <!-- default shown 00 days -->
          <span class="number" v-else>00</span>
          <div class="format">DAYS</div>
          <!-- <div class="format">{{ wordString.day }}</div> -->
      </div>
      <div class="hour">
        <span style="padding: 0 10px 0px 0px;">:</span>
          <span class="number" v-if="starttime !== 0 && endtime !== 0">{{ hours }}</span>
          <!-- default shown 00 hour -->
          <div class="number" v-else>00</div>
          <div class="format">HOURS</div>
          <!-- <div class="format">{{ wordString.hours }}</div> -->
      </div>
      <div class="min">
        <span style="padding: 0 10px 0px 0px;">:</span>
        <span class="number" v-if="starttime !== 0 && endtime !== 0">{{ minutes }}</span>
          <!-- default shown 00 min -->
        <div class="number" v-else>00</div>
        <div class="format">MINUTES</div>
          <!-- <div class="format">{{ wordString.minutes }}</div> -->
      </div>
      <!-- <div class="message">{{ message }}</div>
      <div class="status-tag" :class="statusType">{{ statusText }}</div> -->
    </div>
  </div>
</template>


<script>
export default {
    name: 'Timer',
    // props: [],
    // props: ['starttime','endtime','trans'] ,
    props: {
        starttime: {
        type: String,
        default: 0
        },
        endtime: {
        type: String,
        default: 0
        },
        trans: {
        type: Object,
        default: 0
        },
    },
    mixins: [],
    data(){
        return {
            timer:"",
            wordString: {},
            start: "",
            end: "",
            interval: "",
            days:"",
            minutes:"",
            hours:"",
            seconds:"",
            message:"",
            statusType:"",
            statusText: "",
        }
    },
    mounted(){
      // setHours = hours, minutes, seconds, miliseconds
      let endTime = new Date(this.endtime).setHours(18, 30, 0, 0);        //set time to evening 6:30 clock, because accuracy script is executing at 6 o'clock

      if(this.starttime !== 0 && endTime !== 0){
        this.start = new Date(this.starttime).getTime();
        this.end = new Date(endTime).getTime();
        // Update the count down every 1 second
          this.timerCount(this.start,this.end);
          this.interval = setInterval(() => {
              this.timerCount(this.start,this.end);
          }, 1000);
      }
    },
    methods:{

    timerCount: function(start,end){
        // Get todays date and time
        var now = new Date().getTime();
        // Find the distance between now an the count down date
        var distance = start - now;
        var passTime =  end - now;
        if(distance < 0 && passTime < 0){
            this.message = this.wordString.expired;
            // this.statusType = "expired";
            // this.statusText = this.wordString.status.expired;
            clearInterval(this.interval);
            return;

        }else if(distance < 0 && passTime > 0){
            this.calcTime(passTime);
            // this.message = this.wordString.running;
            // this.statusType = "running";
            // this.statusText = this.wordString.status.running;

        } else if( distance > 0 && passTime > 0 ){
            this.calcTime(distance);
            // this.message = this.wordString.upcoming;
            // this.statusType = "upcoming";
            // this.statusText = this.wordString.status.upcoming;
        }
    },
    calcTime: function(dist){
    // Time calculations for days, hours, minutes and seconds
        this.days = Math.floor(dist / (1000 * 60 * 60 * 24));
        this.hours = Math.floor((dist % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        this.minutes = Math.floor((dist % (1000 * 60 * 60)) / (1000 * 60));
        this.seconds = Math.floor((dist % (1000 * 60)) / 1000);
    }
  }
}
</script>


<style lang="scss" scoped>
  .timer {
    // font-size: 20px;
    color: #fff;
    text-align:center;
    // margin-top: 50px;
    .day, .hour, .min, .sec {
      font-size: 22px;
      display: inline-block;
      font-weight: 500;
      text-align: center;
      // margin: 0 5px;
      .format {
        font-weight: 600;
        font-size: 10px;
        opacity: 0.8;
        margin: 0 5px;
        // width: 60px;
      }
    }
    .number{
      font-weight: 600;
      border-radius: 5px;
      display: inline-block;
      // width: 60px;
      text-align: center;
    }
    .message {
      font-size: 14px;
      font-weight: 400;
      margin-top: 5px;
    }
  }
</style>
